var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "voucherList"
  }, [!_vm.VoucherDefinitionIdProps ? _c('b-card', {
    attrs: {
      "title": _vm.$t('ar_voucher_list_title')
    }
  }, [_c('b-row', {
    staticClass: "mt-1"
  }, [_c('b-col', {
    attrs: {
      "cols": "11",
      "sm": "11"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6",
      "sm": "6"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4",
      "sm": "4"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": _vm.$t('ar_voucher_list_search_vouchercode')
    },
    model: {
      value: _vm.search.VoucherCode,
      callback: function ($$v) {
        _vm.$set(_vm.search, "VoucherCode", $$v);
      },
      expression: "search.VoucherCode"
    }
  })], 1), _c('b-col', {
    attrs: {
      "cols": "4",
      "sm": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "placeholder": _vm.$t('ar_voucher_list_search_voucher_status'),
      "options": _vm.listVoucherStatus
    },
    model: {
      value: _vm.search.VoucherStatus,
      callback: function ($$v) {
        _vm.$set(_vm.search, "VoucherStatus", $$v);
      },
      expression: "search.VoucherStatus"
    }
  })], 1), _c('b-col', {
    attrs: {
      "cols": "4",
      "sm": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "options": _vm.listCompany,
      "placeholder": _vm.$t('ar_voucher_find_name_company')
    },
    model: {
      value: _vm.searchClinentId,
      callback: function ($$v) {
        _vm.searchClinentId = $$v;
      },
      expression: "searchClinentId"
    }
  })], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "6",
      "sm": "6"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4",
      "sm": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "placeholder": _vm.$t('ar_voucher_date_type'),
      "options": _vm.listDateType
    },
    model: {
      value: _vm.dateType,
      callback: function ($$v) {
        _vm.dateType = $$v;
      },
      expression: "dateType"
    }
  })], 1), _c('b-col', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "cols": "4",
      "sm": "4"
    }
  }, [_c('span', {
    staticClass: "w-25"
  }, [_vm._v(_vm._s(_vm.$t("ar_voucher_from_date")))]), _c('date-range-picker', {
    staticClass: "w-75",
    attrs: {
      "single-date-picker": true,
      "opens": "right",
      "ranges": false,
      "time-picker": false,
      "time-picker-increment": 1,
      "show-dropdowns": true,
      "auto-apply": true,
      "locale-data": {
        format: 'mm/dd/YYYY',
        daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        firstDay: 0
      }
    },
    model: {
      value: _vm.openDateDisplay,
      callback: function ($$v) {
        _vm.openDateDisplay = $$v;
      },
      expression: "openDateDisplay"
    }
  })], 1), _c('b-col', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "cols": "4",
      "sm": "4"
    }
  }, [_c('span', {
    staticClass: "w-25"
  }, [_vm._v(_vm._s(_vm.$t("ar_voucher_to_date")))]), _c('date-range-picker', {
    staticClass: "w-75",
    attrs: {
      "single-date-picker": true,
      "opens": "right",
      "ranges": false,
      "time-picker": false,
      "time-picker-increment": 1,
      "show-dropdowns": true,
      "auto-apply": true,
      "locale-data": {
        format: 'mm/dd/YYYY',
        daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        firstDay: 0
      }
    },
    model: {
      value: _vm.expirationDateDisplay,
      callback: function ($$v) {
        _vm.expirationDateDisplay = $$v;
      },
      expression: "expirationDateDisplay"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "1",
      "sm": "1"
    }
  }, [_c('b-button', {
    staticClass: "w-100 h-100 p-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.getListVoucher
    }
  }, [_c('ez-icon', {
    attrs: {
      "icon": "ezAr-icon-search"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("ar_voucher_search")) + " ")], 1)], 1)], 1)], 1) : _vm._e(), _c('b-card', {
    staticClass: "voucherList__table"
  }, [_c('b-row', [_c('b-col', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "left-side d-flex"
  }, [_c('div', {
    staticClass: "d-select-perPage"
  }, [_c('b-form-group', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "label": _vm.$t('ar_voucher_list_result_on_page'),
      "label-for": "h-first-name",
      "label-cols-md": "7"
    }
  }, [_c('v-select', {
    staticStyle: {
      "min-width": "50px"
    },
    attrs: {
      "options": _vm.optionPerPage,
      "clearable": false
    },
    model: {
      value: _vm.perPage,
      callback: function ($$v) {
        _vm.perPage = $$v;
      },
      expression: "perPage"
    }
  })], 1)], 1), _c('div', {
    staticClass: "voucherList__list-states ml-1"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-primary"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("ar_voucher_all")) + ": " + _vm._s(_vm.totalRecordListVoucer) + " ")]), _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "variant": "link"
    }
  }, [_c('span', {
    staticClass: "text-body"
  }, [_vm._v(" " + _vm._s(_vm.$t("ar_voucher_effective")) + ": ")]), _c('span', {
    staticClass: "text-success"
  }, [_vm._v(_vm._s(_vm.totalEffectiveListVoucer))])]), _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "variant": "link"
    }
  }, [_c('span', {
    staticClass: "text-body"
  }, [_vm._v(" " + _vm._s(_vm.$t("ar_voucher_list_voucher_pause")) + ": ")]), _c('span', {
    staticClass: "text-warning"
  }, [_vm._v(_vm._s(_vm.totalPauseListVoucer) + " ")])]), _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "variant": "link"
    }
  }, [_c('span', {
    staticClass: "text-body"
  }, [_vm._v(_vm._s(_vm.$t("ar_voucher_used")) + ":")]), _c('span', {
    staticClass: "text-secondary"
  }, [_vm._v(" " + _vm._s(_vm.totalUsedListVoucer) + " ")])])], 1)]), _c('div', [_c('b-dropdown', {
    attrs: {
      "variant": "outline-primary"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function () {
        return [_c('span', {
          staticClass: "align-middle"
        }, [_vm._v(_vm._s(_vm.$t("ar_voucher_export_file")))])];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', {
    on: {
      "click": _vm.exportExcelListVoucher
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("ar_Voucher_list_export_to_excel")) + " ")]), _c('b-dropdown-item', {
    on: {
      "click": _vm.exportPDFVoucher
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("ar_Voucher_list_export_to_pdf")) + " ")])], 1)], 1)])], 1), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "opacity": 0.3,
      "rounded": "sm"
    }
  }, [_c('DxDataGrid', {
    ref: "tableRate",
    staticStyle: {
      "height": "381px"
    },
    attrs: {
      "data-source": _vm.listVoucher,
      "column-resizing-mode": "widget"
    },
    on: {
      "cellClick": _vm.viewDetailListVoucher
    },
    scopedSlots: _vm._u([{
      key: "ClientName",
      fn: function (_ref) {
        var data = _ref.data;
        return [data.data.ClientName && data.data.ClientName.length >= 27 ? _c('div', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "text-truncate",
          attrs: {
            "title": data.data.ClientName
          }
        }, [_vm._v(" " + _vm._s(data.data.ClientName) + " ")]) : _c('div', [_vm._v(" " + _vm._s(data.data.ClientName) + " ")])];
      }
    }, {
      key: "VoucherCode",
      fn: function (_ref2) {
        var data = _ref2.data;
        return [data.data.VoucherCode.length >= 27 ? _c('div', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "text-truncate",
          attrs: {
            "title": data.data.VoucherCode
          }
        }, [_vm._v(" " + _vm._s(data.data.VoucherCode) + " ")]) : _c('div', [_vm._v(" " + _vm._s(data.data.VoucherCode) + " ")])];
      }
    }, {
      key: "VoucherName",
      fn: function (_ref3) {
        var data = _ref3.data;
        return [data.data.VoucherName.length >= 27 ? _c('div', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "text-truncate",
          attrs: {
            "title": data.data.VoucherName
          }
        }, [_vm._v(" " + _vm._s(data.data.VoucherName) + " ")]) : _c('div', [_vm._v(" " + _vm._s(data.data.VoucherName) + " ")])];
      }
    }, {
      key: "VoucherDefinition",
      fn: function (_ref4) {
        var data = _ref4.data;
        return [_vm._v(" " + _vm._s(data.data.ClientName) + " ")];
      }
    }, {
      key: "WeeklyCode",
      fn: function (_ref5) {
        var data = _ref5.data;
        return [_c('div', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: data.data.WeeklyCode.length >= 5,
            expression: "data.data.WeeklyCode.length >= 5",
            modifiers: {
              "hover": true
            }
          }],
          class: {
            'text-truncate': data.data.WeeklyCode.length >= 5
          },
          attrs: {
            "title": data.data.WeeklyCode
          }
        }, [_vm._v(" " + _vm._s(data.data.WeeklyCode) + " ")])];
      }
    }, {
      key: "MediaTypeId",
      fn: function (_ref6) {
        var data = _ref6.data;
        return [data.data.MediaTypeId ? _c('div', [_vm._v(" " + _vm._s(_vm.listUsesVoucher[data.data.MediaTypeId].label) + " ")]) : _c('div', [_vm._v(" " + _vm._s(_vm.listUsesVoucher[data.data.MediaTypeId].label) + " ")])];
      }
    }, {
      key: "VoucherStatus",
      fn: function (_ref7) {
        var data = _ref7.data;
        return [data.data.VoucherStatus ? _c('div', [data.data.VoucherStatus === 'VALID' ? _c('span', [_vm._v(_vm._s(_vm.$t("ar_voucher_list_voucher_status_valid")))]) : _vm._e(), data.data.VoucherStatus === 'PAUSE' ? _c('span', [_vm._v(_vm._s(_vm.$t("ar_voucher_list_voucher_pause")))]) : _vm._e(), data.data.VoucherStatus === 'USED' ? _c('span', [_vm._v(_vm._s(_vm.$t("ar_voucher_list_voucher_status_used")))]) : _vm._e()]) : _vm._e()];
      }
    }, {
      key: "VoucherStatusEx",
      fn: function (_ref8) {
        var data = _ref8.data;
        return [data.data.VoucherStatusEx ? _c('div', [data.data.VoucherStatusEx === 'N0_EXPIRE' ? _c('span', [_vm._v(_vm._s(_vm.$t("ar_voucher_list_voucher_status_expire")))]) : _vm._e(), data.data.VoucherStatusEx === 'EXPIRE' ? _c('span', [_vm._v(_vm._s(_vm.$t("ar_voucher_list_voucher_status_no_expire")))]) : _vm._e()]) : _vm._e()];
      }
    }, {
      key: "OpenDate",
      fn: function (_ref9) {
        var data = _ref9.data;
        return [data.data.OpenDate ? _c('div', [_vm._v(" " + _vm._s(_vm.convertUTC(data.data.OpenDate, "DD/MM/YYYY")) + " ")]) : _vm._e()];
      }
    }, {
      key: "ExpirationDate",
      fn: function (_ref10) {
        var data = _ref10.data;
        return [data.data.ExpirationDate ? _c('div', [_vm._v(" " + _vm._s(_vm.convertUTC(data.data.ExpirationDate, "DD/MM/YYYY")) + " ")]) : _vm._e()];
      }
    }, {
      key: "action",
      fn: function (_ref11) {
        var data = _ref11.data;
        return [_c('b-dropdown', {
          staticClass: "w-100",
          attrs: {
            "size": "lg",
            "variant": "link",
            "toggle-class": "text-decoration-none",
            "right": ""
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function () {
              return [_c('feather-icon', {
                staticClass: "mx-auto",
                attrs: {
                  "icon": "MoreVerticalIcon",
                  "color": "#114A9F"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [_c('b-dropdown-item', {
          on: {
            "click": function ($event) {
              return _vm.handleClickDetailVoucher(data.data.Id);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("ar_voucher_list_voucher_show_detail")) + " ")]), data.data.VoucherStatus === 'PAUSE' ? _c('b-dropdown-item', {
          on: {
            "click": function ($event) {
              _vm.$refs.confirmValid.open({
                Id: data.data.Id,
                dataConfirm: {
                  title: _vm.$t('ar_voucher_list_voucher_re_pause'),
                  content: _vm.$t('ar_voucher_list_voucher_mess_pause')
                }
              });
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("ar_voucher_list_voucher_re_pause")) + " ")]) : _c('b-dropdown-item', {
          on: {
            "click": function ($event) {
              _vm.$refs.confirmInValid.open({
                Id: data.data.Id,
                dataConfirm: {
                  title: _vm.$t('ar_vouhcer_disable'),
                  content: _vm.$t('ar_vouhcer_disable_mess')
                }
              });
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("ar_voucher_list_voucher_pause")) + " ")]), _c('b-dropdown-divider'), _c('b-dropdown-item', {
          on: {
            "click": function ($event) {
              return _vm.$refs.confirmDelete.open({
                Id: data.data.Id,
                dataConfirm: {
                  title: 'Xóa voucher',
                  content: 'Bạn có chắc chắn xóa Voucher?'
                }
              });
            }
          }
        }, [_c('span', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(_vm.$t("ar_voucher_list_voucher_delete")))])])], 1)];
      }
    }])
  }, [_c('DxFilterRow', {
    attrs: {
      "visible": true
    }
  }), _vm._l(_vm.configTable, function (item, index) {
    return _c('DxColumn', {
      key: index,
      attrs: {
        "caption": item.caption,
        "data-field": item.field,
        "cell-template": item.cellTemplate ? item.cellTemplate : false,
        "allow-column-resizing": true,
        "column-auto-width": true,
        "alignment": item.alignment,
        "width": item.width,
        "allowFiltering": item.field != 'action' ? true : false
      }
    });
  }), _c('DxScrolling', {
    attrs: {
      "mode": "virtual",
      "row-rendering-mode": "virtual"
    }
  }), _c('DxPaging', {
    attrs: {
      "page-size": _vm.perPage
    }
  })], 2)], 1)], 1), _c('Pagination', {
    attrs: {
      "currentPage": _vm.currentPageDisplay,
      "perPage": _vm.perPage,
      "rows": _vm.totalRecordListVoucer,
      "hasStatistical": true
    },
    on: {
      "update:currentPage": function ($event) {
        _vm.currentPageDisplay = $event;
      },
      "update:current-page": function ($event) {
        _vm.currentPageDisplay = $event;
      }
    }
  }), _c('confirm-dialog', {
    ref: "confirmDelete",
    on: {
      "confirmDialog": _vm.DeleteVoucher
    }
  }), _c('confirm-dialog', {
    ref: "confirmValid",
    on: {
      "confirmDialog": _vm.validDetailVoucher
    }
  }), _c('confirm-dialog', {
    ref: "confirmInValid",
    on: {
      "confirmDialog": _vm.invalidDetailVoucher
    }
  }), _c('VocherDetail', {
    ref: "VocherDetail",
    attrs: {
      "voucherDetailId": _vm.voucherDetailId,
      "isOpen": _vm.isShowModalDetails
    },
    on: {
      "update:voucherDetailId": function ($event) {
        _vm.voucherDetailId = $event;
      },
      "update:voucher-detail-id": function ($event) {
        _vm.voucherDetailId = $event;
      },
      "update:isOpen": function ($event) {
        _vm.isShowModalDetails = $event;
      },
      "update:is-open": function ($event) {
        _vm.isShowModalDetails = $event;
      },
      "event": _vm.handleEvent,
      "PAUSED": _vm.confirmInvalid,
      "VALID": _vm.confirmValid
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }